import FocusMachine from "./focusMachine";

import styled from "styled-components";

function App() {
  return (
    <AppContainer>
      <FocusMachine />
    </AppContainer>
  );
}

const AppContainer = styled.div``;

export default App;
